/* eslint-disable @typescript-eslint/naming-convention */
import classNames from 'clsx';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import type { PromotionBanner } from '@swf/cms';
import { CMSHTML } from '@swf/cms';
import { select } from '@swf/core/store';
import getBackgroundImageStyle from '@swf/core/utils/getBackgroundImageStyle';

import CMSPreloadImage from '../CMSPreloadImage/CMSPreloadImage';

import cssStyles from './CMSPromotionBanner.scss';

const CMSPromitionBanner: React.FC<PromotionBanner> = ({ background_color, items, file }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeItem, setActiveItem] = useState(items[0]);
  const isMobile = useSelector(select.device.isMobile);
  const desktopImageUrl = activeItem.content_item.desktop_image.asset?.url;
  const mobileImageUrl = activeItem.content_item.mobile_image.asset?.url;
  const imgUrl = isMobile ? mobileImageUrl || desktopImageUrl : desktopImageUrl || mobileImageUrl;

  const navigationItems = items
    .map((item) => item.content_item.navigation)
    .filter((item) => item.html.content);

  const onIndexChange = (index: number) => {
    setActiveIndex(index);
    setActiveItem(items[index]);
  };

  return (
    <>
      {imgUrl && <CMSPreloadImage imageUrl={imgUrl} />}
      <Helmet>
        <style type="text/css">{`
        .title {
          border-radius: 20px;
          background-color: rgba(0, 0, 0, 0.6);
          padding: 10px;
        }

        #promotion-container {
            background-image: url("${activeItem.content_item.desktop_image.asset?.url}");
        }

        @media only screen and (max-width: 725px) {
          #promotion-container {
            background-image: url("${imgUrl}");
          }
        }
    `}</style>
        <link href={file?.url} rel="stylesheet" />
      </Helmet>
      <div
        id="promotion-container"
        className={classNames(
          {
            [cssStyles.container]: !navigationItems.length,
            [cssStyles.navContainer]: navigationItems.length
          },
          background_color && cssStyles[`${background_color}Background`]
        )}
      >
        <div
          id="promotion-banner"
          className={classNames(cssStyles.banner, {
            [cssStyles.navBanner]: navigationItems.length
          })}
        >
          <CMSHTML className={classNames(cssStyles.content)} {...activeItem.content_item.html} />
          {!!navigationItems.length && (
            <div className={classNames(cssStyles.navigation)}>
              {navigationItems.map((item, index) => (
                <div
                  key={index}
                  onClick={() => onIndexChange(index)}
                  className={classNames(
                    index === activeIndex ? `${cssStyles.activeNav}` : '',
                    cssStyles.navItem
                  )}
                  style={getBackgroundImageStyle(item.image.asset?.url)}
                >
                  <CMSHTML className={cssStyles.bannerItem} {...item.html} />
                </div>
              ))}
            </div>
          )}
          {!!activeItem.foot_note && <p className={cssStyles.footNote}>{activeItem.foot_note}</p>}
        </div>
      </div>
    </>
  );
};

export default CMSPromitionBanner;
